import { Fragment } from "react/jsx-runtime";
import { IntegrationAddHeader } from "../headers/IntegrationAddHeader";
import { ChatIntegrationName } from "./utils/chatOpsTypes";
import { ChatOpsMsTeamsForm } from "./forms/ChatOpsMsTeamsForm";
import { ChatOpsSlackForm } from "./forms/ChatOpsSlackForm";
import { ChatOpsTelegramForm } from "./forms/ChatOpsTelegramForm";
import { ChatOpsWebhookForm } from "./forms/ChatOpsWebhookForm";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";
import { OtherIntegrations } from "../headers/types";

interface ChatOpsIntegrationsProps {
  scope: SpaceScope | OrganizationScope;
  view: ChatIntegrationName;
}

export function ChatOpsIntegrations(props: ChatOpsIntegrationsProps) {
  const { view } = props;

  const forms = {
    [ChatIntegrationName.Msteams]: ChatOpsMsTeamsForm,
    [ChatIntegrationName.Slack]: ChatOpsSlackForm,
    [ChatIntegrationName.Telegram]: ChatOpsTelegramForm,
    [ChatIntegrationName.Httppost]: ChatOpsWebhookForm,
  };

  const Form = forms[view];

  return (
    <Fragment>
      <IntegrationAddHeader
        type={`chatops/${props.view}` as OtherIntegrations}
      />
      {Form && <Form {...props} />}
    </Fragment>
  );
}
